/* =========================================================
   Monte seu kit — Bendita Cânfora
   Estado do kit no navegador (localStorage, com try/catch).
   Envio ao carrinho: POST /cart/add.js com `items` + `sections`
   do <cart-drawer>, depois cartDrawer.renderContents(data) —
   mesmo padrão do combo-produtos / product-form do tema.
   ========================================================= */
(function () {
  'use strict';

  var MAX_DEFAULT = 99;

  function fmt(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function storageGet(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      if (value == null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* modo privado / bloqueado: segue só em memória */
    }
  }

  function KitBuilder(root) {
    this.root = root;
    this.threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    this.storageKey = root.getAttribute('data-storage-key') || 'bc-kit-builder';
    this.cartTotal = 0;
    this.busy = false;
    this.products = {};
    this.state = []; // [{ v: '123', q: 1 }] na ordem em que entraram

    var self = this;
    root.querySelectorAll('[data-kb-card]').forEach(function (card) {
      var v = card.getAttribute('data-variant');
      if (!v) return;
      self.products[v] = {
        v: v,
        title: card.getAttribute('data-title') || '',
        price: parseInt(card.getAttribute('data-price'), 10) || 0,
        image: card.getAttribute('data-image') || '',
        // data-max="0" = esgotado (não pode cair no fallback de 99)
        max: card.getAttribute('data-max') === '0' ? 0 : parseInt(card.getAttribute('data-max'), 10) || MAX_DEFAULT,
        unitCents: parseInt(card.getAttribute('data-unit-cents'), 10) || 0,
        unitLabel: card.getAttribute('data-unit-label') || '',
        pastilhas: parseInt(card.getAttribute('data-pastilhas'), 10) || 0,
        tabletes: parseInt(card.getAttribute('data-tabletes'), 10) || 0,
        sprays: parseInt(card.getAttribute('data-sprays'), 10) || 0,
        card: card,
      };
    });

    this.restore();
    this.bind();
    this.setupSticky();
    this.setupNav();
    this.render();
    this.fetchCart();
  }

  KitBuilder.prototype.restore = function () {
    var saved = storageGet(this.storageKey);
    if (!Array.isArray(saved)) return;
    var self = this;
    this.state = saved
      .filter(function (it) { return it && self.products[it.v] && self.products[it.v].max > 0 && it.q > 0; })
      .map(function (it) {
        return { v: String(it.v), q: Math.min(parseInt(it.q, 10) || 1, self.products[it.v].max) };
      });
  };

  KitBuilder.prototype.save = function () {
    storageSet(this.storageKey, this.state.length ? this.state : null);
  };

  KitBuilder.prototype.find = function (v) {
    for (var i = 0; i < this.state.length; i++) if (this.state[i].v === v) return this.state[i];
    return null;
  };

  KitBuilder.prototype.add = function (v) {
    var p = this.products[v];
    if (!p || p.max < 1) return;
    var it = this.find(v);
    if (it) {
      if (it.q >= p.max) return;
      it.q += 1;
    } else {
      this.state.push({ v: v, q: 1 });
    }
    this.clearError();
    this.render();
  };

  /* "−" do card no mobile: tira 1 unidade; em 0 sai do kit */
  KitBuilder.prototype.decrement = function (v) {
    var it = this.find(v);
    if (!it) return;
    if (it.q <= 1) return this.remove(v);
    it.q -= 1;
    this.render();
  };

  KitBuilder.prototype.remove = function (v) {
    this.state = this.state.filter(function (it) { return it.v !== v; });
    this.render();
  };

  KitBuilder.prototype.kitTotal = function () {
    var self = this;
    return this.state.reduce(function (sum, it) { return sum + self.products[it.v].price * it.q; }, 0);
  };

  KitBuilder.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-kb-add], [data-kb-inc]');
      if (addBtn) {
        var card = addBtn.closest('[data-kb-card]');
        if (card) self.add(card.getAttribute('data-variant'));
        return;
      }
      var dec = e.target.closest('[data-kb-dec]');
      if (dec) {
        var decCard = dec.closest('[data-kb-card]');
        if (decCard) self.decrement(decCard.getAttribute('data-variant'));
        return;
      }
      var rm = e.target.closest('[data-kb-remove]');
      if (rm) return self.remove(rm.getAttribute('data-kb-remove'));
      var cta = e.target.closest('[data-kb-cta]');
      if (cta) return self.submit();
    });

    // carrinho mudou em outro lugar (drawer, cross-sell): refaz a barra de frete
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.cartData && typeof evt.cartData.total_price === 'number') {
          self.cartTotal = evt.cartData.total_price;
          self.renderShipping();
        } else {
          self.fetchCart();
        }
      });
    }
  };

  KitBuilder.prototype.fetchCart = function () {
    var self = this;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        self.cartTotal = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        self.renderShipping();
      })
      .catch(function () {});
  };

  /* ---------- render ---------- */
  function plural(n, one, many) {
    return n.toLocaleString('pt-BR') + ' ' + (n === 1 ? one : many);
  }

  function joinPt(parts) {
    if (parts.length <= 1) return parts.join('');
    return parts.slice(0, -1).join(', ') + ' e ' + parts[parts.length - 1];
  }

  KitBuilder.prototype.tileHtml = function (it) {
    var p = this.products[it.v];
    return (
      '<div class="bc-kb__tile">' +
      '<button type="button" class="bc-kb__tile-remove" data-kb-remove="' + p.v + '" aria-label="Remover ' + esc(p.title) + ' do kit">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M17 7 7 17M7 7l10 10"/></svg>' +
      '</button>' +
      '<span class="bc-kb__tile-photo">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="" width="80" height="80" loading="lazy">' : '') +
      '</span>' +
      '<span class="bc-kb__tile-title">' + esc(p.title) + '</span>' +
      '<span class="bc-kb__tile-price">' + fmt(p.price) + '</span>' +
      (p.unitCents > 0 && p.unitLabel
        ? '<span class="bc-kb__tile-unit">' + fmt(p.unitCents) + ' por ' + esc(p.unitLabel) + '</span>'
        : '') +
      '<span class="bc-kb__tile-qty" aria-label="Quantidade ' + it.q + '">× ' + it.q + '</span>' +
      '</div>'
    );
  };

  /* "Seu kit tem 120 pastilhas e 1 spray" + valor médio só com um tipo de item */
  KitBuilder.prototype.summaryHtml = function (total) {
    var self = this;
    var c = { pastilhas: 0, tabletes: 0, sprays: 0 };
    this.state.forEach(function (it) {
      var p = self.products[it.v];
      c.pastilhas += p.pastilhas * it.q;
      c.tabletes += p.tabletes * it.q;
      c.sprays += p.sprays * it.q;
    });
    var parts = [];
    if (c.pastilhas) parts.push(plural(c.pastilhas, 'pastilha', 'pastilhas'));
    if (c.tabletes) parts.push(plural(c.tabletes, 'tablete', 'tabletes'));
    if (c.sprays) parts.push(plural(c.sprays, 'spray', 'sprays'));
    if (!parts.length) return '';

    var html = '<p class="bc-kb__summary-main">Seu kit tem <strong>' + joinPt(parts) + '</strong></p>';
    if (parts.length === 1) {
      var n = c.pastilhas || c.tabletes || c.sprays;
      var label = c.pastilhas ? 'pastilha' : c.tabletes ? 'tablete' : 'spray';
      html += '<p class="bc-kb__summary-avg">Valor médio: <strong>' + fmt(Math.round(total / n)) + '</strong> por ' + label + '</p>';
    }
    return html;
  };

  KitBuilder.prototype.render = function () {
    var self = this;
    var total = this.kitTotal();
    var tiles = this.state.map(function (it) { return self.tileHtml(it); }).join('');
    var summary = this.state.length ? this.summaryHtml(total) : '';

    this.root.querySelectorAll('[data-kb-items]').forEach(function (box) {
      box.classList.toggle('has-items', !!tiles);
      box.innerHTML = tiles || '<p class="bc-kb__empty">' + esc(box.getAttribute('data-empty')) + '</p>';
    });
    this.root.querySelectorAll('[data-kb-summary]').forEach(function (box) {
      box.innerHTML = summary;
      box.hidden = !summary;
    });

    this.root.querySelectorAll('[data-kb-total]').forEach(function (el) { el.textContent = fmt(total); });
    this.root.querySelectorAll('[data-kb-cta-price]').forEach(function (el) { el.textContent = fmt(total); });
    this.root.querySelectorAll('[data-kb-cta]').forEach(function (btn) {
      btn.disabled = !self.state.length || self.busy;
    });

    Object.keys(this.products).forEach(function (v) {
      var p = self.products[v];
      var it = self.find(v);
      var q = it ? it.q : 0;
      p.card.classList.toggle('is-in-kit', q > 0);
      p.card.querySelectorAll('[data-kb-card-count]').forEach(function (pill) {
        pill.hidden = q === 0;
        pill.textContent = q ? 'No seu kit · ' + q : '';
      });
      p.card.querySelectorAll('[data-kb-card-ctl]').forEach(function (ctl) {
        ctl.hidden = q === 0;
      });
      var addBtn = p.card.querySelector('[data-kb-add]');
      if (addBtn && p.max > 0) {
        var atMax = q >= p.max;
        addBtn.disabled = atMax;
        addBtn.textContent = atMax ? 'Limite de ' + p.max + ' por pedido' : addBtn.getAttribute('data-label') || '+ Adicionar ao kit';
      }
      p.card.querySelectorAll('[data-kb-inc]').forEach(function (inc) {
        inc.disabled = q >= p.max;
      });
    });

    this.renderShipping();
    this.save();
  };

  KitBuilder.prototype.renderShipping = function () {
    var sum = this.cartTotal + this.kitTotal();
    var remaining = Math.max(0, this.threshold - sum);
    var pct = this.threshold > 0 ? Math.min(100, (sum / this.threshold) * 100) : 100;
    var html = remaining > 0
      ? 'Faltam <strong>' + fmt(remaining) + '</strong> para o frete grátis'
      : '<strong>Frete grátis garantido!</strong>';

    this.root.querySelectorAll('[data-kb-ship-text]').forEach(function (el) { el.innerHTML = html; });
    this.root.querySelectorAll('[data-kb-ship-fill]').forEach(function (el) { el.style.width = pct + '%'; });
    this.root.querySelectorAll('[data-kb-ship]').forEach(function (el) {
      el.setAttribute('data-complete', remaining > 0 ? 'false' : 'true');
    });
  };

  /* ---------- carrinho ---------- */
  KitBuilder.prototype.showError = function (msg) {
    this.root.querySelectorAll('[data-kb-error]').forEach(function (el) {
      el.textContent = msg;
      el.hidden = false;
    });
  };

  KitBuilder.prototype.clearError = function () {
    this.root.querySelectorAll('[data-kb-error]').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
    });
  };

  KitBuilder.prototype.setLoading = function (on) {
    this.busy = on;
    var self = this;
    this.root.querySelectorAll('[data-kb-cta]').forEach(function (btn) {
      btn.classList.toggle('is-loading', on);
      btn.disabled = on || !self.state.length;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  };

  KitBuilder.prototype.submit = function () {
    if (this.busy || !this.state.length) return;
    var self = this;
    var cartDrawer = document.querySelector('cart-drawer');
    var body = {
      items: this.state.map(function (it) { return { id: parseInt(it.v, 10), quantity: it.q }; }),
    };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(document.activeElement);
    }

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    this.clearError();
    this.setLoading(true);

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        self.state = [];
        self.setLoading(false);
        self.render();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bc-kit-builder', cartData: data });
        }
        self.fetchCart();

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        self.setLoading(false);
        self.showError(
          (err && (err.description || err.message)) || 'Não foi possível adicionar ao carrinho. Tente novamente.'
        );
      });
  };

  /* ---------- sticky: header do tema + barra mobile ---------- */
  KitBuilder.prototype.setupSticky = function () {
    var root = this.root;
    var header = document.querySelector('.shopify-section-header-sticky') || null;
    var bar = root.querySelector('[data-kb-bar]');
    var ticking = false;

    function update() {
      ticking = false;
      var top = 0;
      if (header) {
        var r = header.getBoundingClientRect();
        top = Math.max(0, Math.round(r.bottom));
      }
      root.style.setProperty('--kb-top', top + 'px');
      if (bar) {
        var h = bar.offsetHeight || 0;
        root.style.setProperty('--kb-bar-h', h + 'px');
        document.documentElement.style.setProperty('--kb-bar-h', h + 'px');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  };

  /* ---------- navegação entre grupos ---------- */
  KitBuilder.prototype.setupNav = function () {
    var root = this.root;
    var buttons = root.querySelectorAll('[data-kb-nav-btn]');
    if (!buttons.length) return;

    function setActive(id) {
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-target') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    var lockUntil = 0;
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var target = document.getElementById(b.getAttribute('data-target'));
        if (!target) return;
        setActive(target.id);
        lockUntil = Date.now() + 900;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (!('IntersectionObserver' in window)) return;
    var groups = root.querySelectorAll('[data-kb-group][id]');
    var io = new IntersectionObserver(
      function (entries) {
        if (Date.now() < lockUntil) return;
        var best = null;
        entries.forEach(function (en) {
          if (en.isIntersecting && (!best || en.boundingClientRect.top < best.boundingClientRect.top)) best = en;
        });
        if (best) setActive(best.target.id);
      },
      { rootMargin: '-35% 0px -55% 0px', threshold: 0 }
    );
    groups.forEach(function (g) { io.observe(g); });
  };

  function init() {
    document.querySelectorAll('[data-kb-root]').forEach(function (root) {
      if (root.__kb) return;
      root.__kb = new KitBuilder(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // editor de tema: re-render da seção
  document.addEventListener('shopify:section:load', init);
})();
